var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"main-title",staticStyle:{"font-size":"28px","font-weight":"600","color":"#525252"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"sub-title",staticStyle:{"font-size":"13px","font-weight":"500","color":"#6e737f"}},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }